module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/styles/fonts/glyphicons/glyphicons-halflings-regular.woff
// module id = ../../../../../src/assets/styles/fonts/glyphicons/glyphicons-halflings-regular.woff
// module chunks = styles